import { PUBLIC_LAYOUT } from '@/constants/layouts'
import { FOOTER_COMPONENT_NAMES } from '@/components/public/footers/index'
import i18n from '@/plugins/i18n'
import { UNIPROMEL_THEME } from '@/constants/themes'

const layout = PUBLIC_LAYOUT
const footer = {
  component: FOOTER_COMPONENT_NAMES.UNIPROMEL
}

const tagLine = 'Unihealth'

export default [
  {
    path: '/',
    name: 'Unipromel',
    component: () => import('@/components/views/unipromel/Unipromel'),
		beforeEnter: (to, from, next) => {
			this.$helpers.goToProfessionalsLanding()
		},
    meta: {
      tagLine,
      title: {
        text () {
          return i18n.t('unipromel.title')
        }
      },
      layout,
      footer,
      theme: UNIPROMEL_THEME,
      i18n: 'public/views/unipromel'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/unipromel.routes.js